import React, { createContext, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useOpts } from '../../../context';
import usePercentageSupported from './hooks/usePercentageSupported';
import { selectFeatureFlags } from '../../../state/slices/slice-link-params';
var noop = function () { };
export var fullSwitchAndMoreContext = createContext({
    error: null,
    setError: noop,
    isValid: false,
    percentageSupported: false,
    selectionType: null,
});
var FullSwitchAndMoreProvider = function (props) {
    var opts = useOpts();
    var amountSelection = opts.amountSelection;
    var featureFlags = useSelector(selectFeatureFlags);
    var _a = useState(), error = _a[0], setError = _a[1];
    var selectionType = useMemo(function () {
        return (amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.action) === 'full_switch'
            ? 'full_switch'
            : amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.allocation.type;
    }, [amountSelection]);
    // Unset error if amount selection type changes
    useEffect(function () { return setError(undefined); }, [selectionType]);
    var percentageSupported = usePercentageSupported();
    var isValid = useMemo(function () {
        if ((amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.action) === 'full_switch')
            return true;
        if ((amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.allocation.type) === 'remainder')
            return !featureFlags.disableRemainderSwitch;
        return !!(amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.allocation.value) && !error;
    }, [amountSelection, error, featureFlags.disableRemainderSwitch]);
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    var contextValue = {
        error: error,
        setError: setError,
        isValid: isValid,
        percentageSupported: percentageSupported,
        selectionType: selectionType,
    };
    return (React.createElement(fullSwitchAndMoreContext.Provider, { value: contextValue }, props.children));
};
export default FullSwitchAndMoreProvider;
